// Module
var code = "<a data-bind=\"tooltip: Tooltip,click: OnClick, visible: ViewModel.DisplayValue\" class=\"config\"> </a> <!--ko template: {name: $data.GetPropsTemplateName.bind($data)}--> <!--/ko-->";
// Exports
export default code;